import {
  errorToast,
  IErrorMessage,
  ISuccessMessage,
  List,
  renderToastContainer,
  successToast,
  TemplateAdminForm
} from 'enchoice-fabric-react-lib';
import { CommandBar, IColumn, IObjectWithKey, Selection, SelectionMode } from 'office-ui-fabric-react';
import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router';
import 'react-toastify/dist/ReactToastify.css';
import { Dispatch } from 'redux';
import Api from '../../../components/Api';
import { updateBreadCrumbs } from '../../../redux/Actions/BreadCrumbs/ActionCreators';
import './TemplateAdmin.css';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateBreadCrumbs: (items: IBreadcrumbItem[]) => dispatch(updateBreadCrumbs(items))
  };
};

const URL_BASE = '';

const divStyle = {
  height: 'calc(100% - 85px)',
  fallbacks: [{ height: '-moz-calc(100% - 85px)' }, { height: '-webkit-calc(100% - 85px)' }, { height: '-o-calc(100% - 85px)' }]
};

class TemplateAdmin extends React.PureComponent<any, any> {
  private selection: Selection;

  constructor(props: any) {
    super(props);

    const {
      match: { params }
    } = this.props;

    this.state = {
      templateId: params.templateId,
      showList: true
    };

    this.onCancel = this.onCancel.bind(this);
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
    this.onSubmitError = this.onSubmitError.bind(this);
    this.isNull = this.isNull.bind(this);
    this.getUrl = this.getUrl.bind(this);
    this.onCustomBuildColumns = this.onCustomBuildColumns.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onNew = this.onNew.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.getDynamicTranslationInternal = this.getDynamicTranslationInternal.bind(this);

    this.selection = new Selection({
      getKey: (item: IObjectWithKey, index?: number | undefined): string | number => {
        return item && (item as any).id ? (item as any).id : `${index}`;
      },
      onSelectionChanged: () => {
        this.onSelectionChanged(this.selection.getSelection());
      }
    });
  }

  public componentDidUpdate(prevProps: any) {
    console.log('componentDidUpdate');

    const lastIdArray = /\d+/.exec(prevProps.location.pathname);
    const id = this.getId();

    if (lastIdArray === null && id == null) {
      this.setState({ showList: false }, () => this.setState({ showList: true }));
    }

    if (lastIdArray) {
      const lastId = lastIdArray[0];

      if (lastId && id == null) {
        this.setState({ showList: false }, () => this.setState({ showList: true }));
      }
    }
  }

  public componentDidMount() {
    const { t } = this.props;

    const items: IBreadcrumbItem[] = [
      { text: t('templateAdmin.breadcrumb.home'), key: '/home' },
      { text: t('templateAdmin.breadcrumb.1level'), key: `/search/template`, isCurrentItem: true }
    ];
    this.props.updateBreadCrumbs(items);
  }

  public render(): JSX.Element {
    const { t, match } = this.props;

    const id = this.getId();

    return (
      <div className="ms-Grid" dir="ltr" style={{ padding: 0, height: '100%' }}>
        <div className="ms-Grid-row" style={{ height: '100%' }}>
          <div className="ms-Grid-col ms-sm4" style={{ padding: 0, height: '100%', borderRight: '1px solid #eaeaea' }}>
            <CommandBar
              items={this.getItems()}
              farItems={this.getFarItems()}
              ariaLabel={'Use left and right arrow keys to navigate between commands'}
            />
            {this.state.showList && (
              <div style={divStyle}>
                <List
                  getUrl={this.getUrl}
                  handleResponse={this.handleResponse}
                  onCustomBuildColumns={this.onCustomBuildColumns}
                  selection={this.selection}
                  selectionMode={SelectionMode.single}
                  selectKeyOnInit={`${id}`}
                  enableSearch={true}
                  enableSort={true}
                  height={'100%'}
                  underlined={true}
                  styles={{ root: { marginTop: '5px', height: '100%' } }}
                />
              </div>
            )}
          </div>
          <div className="ms-Grid-col ms-sm8" style={{ padding: 0 }}>
            <Switch>
              <Route
                exact={true}
                path={`${match.url}/new`}
                // tslint:disable-next-line:jsx-no-lambda
                render={props => (
                  <TemplateAdminForm
                    baseUrl={URL_BASE}
                    onCancel={this.onCancel}
                    onSubmitSuccess={this.onSubmitSuccess}
                    onSubmitError={this.onSubmitError}
                    getDynamicTranslation={this.getDynamicTranslationInternal}
                    titleOnPanels={true}
                    allowMenus={false}
                    allowDisplayProperties={false}
                    labelTitleNew={t('templateAdmin.title.new')}
                    labelTitleEdit={t('templateAdmin.title.edit')}
                    labelFormTemplateName={t('templateAdmin.form.templateName')}
                    labelCmdBarBtnSave={t('templateAdmin.cmdBar.main.save')}
                    labelCmdBarBtnEdit={t('templateAdmin.cmdBar.main.edit')}
                    labelCmdBarBtnCancel={t('templateAdmin.cmdBar.main.cancel')}
                    labelCmdBarFarBtnAdd={t('templateAdmin.cmdBar.far.addProperty')}
                    labelCmdBarFarBtnReset={t('templateAdmin.cmdBar.far.reset')}
                    labelCmdBarFarBtnResults={t('templateAdmin.cmdBar.far.results')}
                    labelDialogTitleDelete={t('templateAdmin.dialog.delete.title')}
                    labelDialogSubtextPrefixDelete={t('templateAdmin.dialog.delete.subtext.prefix')}
                    labelDialogSubtextSuffixDelete={t('templateAdmin.dialog.delete.subtext.suffix')}
                    labelDialogBtnDelete={t('templateAdmin.dialog.delete.buttons.delete')}
                    labelDialogBtnCancel={t('templateAdmin.dialog.delete.buttons.cancel')}
                    labelDialogTitleReset={t('templateAdmin.dialog.reset.title')}
                    labelDialogSubtextReset={t('templateAdmin.dialog.reset.subtext')}
                    labelDialogBtnReset={t('templateAdmin.dialog.reset.buttons.reset')}
                    labelPanelSettingsPropertyTitle={t('templateAdmin.panel.settings.title')}
                    labelPanelSettingsOperatorsTitle={t('templateAdmin.panel.settings.operators.title')}
                    labelPanelSettingsBtnUseAll={t('templateAdmin.panel.settings.buttons.all')}
                    labelPanelSettingsBtnUseSelected={t('templateAdmin.panel.settings.buttons.selected')}
                    labelPanelSettingsEquals={t('templateAdmin.panel.settings.operators.equals')}
                    labelPanelSettingsStartsWith={t('templateAdmin.panel.settings.operators.startsWith')}
                    labelPanelSettingsContains={t('templateAdmin.panel.settings.operators.contains')}
                    labelPanelSettingsIsEmpty={t('templateAdmin.panel.settings.operators.empty')}
                    labelPanelSettingsGreaterThan={t('templateAdmin.panel.settings.operators.gt')}
                    labelPanelSettingsLessThan={t('templateAdmin.panel.settings.operators.lt')}
                    labelPanelSettingsWithin={t('templateAdmin.panel.settings.operators.within')}
                    labelPanelSettingsIncludes={t('templateAdmin.panel.settings.operators.includes')}
                    labelPanelDisplayPropertiesTitle={t('templateAdmin.panel.display.title')}
                    labelPanelAddPropertiesTitle={t('templateAdmin.panel.addProperties.title')}
                    labelPanelAddPropertiesProperty={t('templateAdmin.panel.addProperties.property')}
                    labelPanelAddBtnAdd={t('templateAdmin.panel.addProperties.buttons.add')}
                    labelPanelAddBtnCancel={t('templateAdmin.panel.addProperties.buttons.cancel')}
                    labelMovListAvailable={t('templateAdmin.move.available')}
                    labelMovListSelected={t('templateAdmin.move.selected')}
                    labelIconOperatorDelete={t('templateAdmin.form.icons.delete')}
                    labelIconOperatorSetting={t('templateAdmin.form.icons.settings')}
                    labelIconOperatorUp={t('templateAdmin.form.icons.up')}
                    labelIconOperatorDown={t('templateAdmin.form.icons.down')}
                    labelPanelMenusTitle={t('templateAdmin.panel.menus.title')}
                  />
                )}
              />
              <Route
                exact={true}
                path={`${match.url}/:templateId(\\d+)/edit`}
                // tslint:disable-next-line:jsx-no-lambda
                render={props => (
                  <div>
                    <TemplateAdminForm
                      baseUrl={URL_BASE}
                      id={props.match.params.templateId}
                      onCancel={this.onCancel}
                      onSubmitSuccess={this.onSubmitSuccess}
                      onSubmitError={this.onSubmitError}
                      getDynamicTranslation={this.getDynamicTranslationInternal}
                      titleOnPanels={true}
                      allowMenus={false}
                      allowDisplayProperties={false}
                      labelTitleNew={t('templateAdmin.title.new')}
                      labelTitleEdit={t('templateAdmin.title.edit')}
                      labelFormTemplateName={t('templateAdmin.form.templateName')}
                      labelCmdBarBtnSave={t('templateAdmin.cmdBar.main.save')}
                      labelCmdBarBtnEdit={t('templateAdmin.cmdBar.main.edit')}
                      labelCmdBarBtnCancel={t('templateAdmin.cmdBar.main.cancel')}
                      labelCmdBarFarBtnAdd={t('templateAdmin.cmdBar.far.addProperty')}
                      labelCmdBarFarBtnReset={t('templateAdmin.cmdBar.far.reset')}
                      labelCmdBarFarBtnResults={t('templateAdmin.cmdBar.far.results')}
                      labelDialogTitleDelete={t('templateAdmin.dialog.delete.title')}
                      labelDialogSubtextPrefixDelete={t('templateAdmin.dialog.delete.subtext.prefix')}
                      labelDialogSubtextSuffixDelete={t('templateAdmin.dialog.delete.subtext.suffix')}
                      labelDialogBtnDelete={t('templateAdmin.dialog.delete.buttons.delete')}
                      labelDialogBtnCancel={t('templateAdmin.dialog.delete.buttons.cancel')}
                      labelDialogTitleReset={t('templateAdmin.dialog.reset.title')}
                      labelDialogSubtextReset={t('templateAdmin.dialog.reset.subtext')}
                      labelDialogBtnReset={t('templateAdmin.dialog.reset.buttons.reset')}
                      labelPanelSettingsPropertyTitle={t('templateAdmin.panel.settings.title')}
                      labelPanelSettingsOperatorsTitle={t('templateAdmin.panel.settings.operators.title')}
                      labelPanelSettingsBtnUseAll={t('templateAdmin.panel.settings.buttons.all')}
                      labelPanelSettingsBtnUseSelected={t('templateAdmin.panel.settings.buttons.selected')}
                      labelPanelSettingsEquals={t('templateAdmin.panel.settings.operators.equals')}
                      labelPanelSettingsStartsWith={t('templateAdmin.panel.settings.operators.startsWith')}
                      labelPanelSettingsContains={t('templateAdmin.panel.settings.operators.contains')}
                      labelPanelSettingsIsEmpty={t('templateAdmin.panel.settings.operators.empty')}
                      labelPanelSettingsGreaterThan={t('templateAdmin.panel.settings.operators.gt')}
                      labelPanelSettingsLessThan={t('templateAdmin.panel.settings.operators.lt')}
                      labelPanelSettingsWithin={t('templateAdmin.panel.settings.operators.within')}
                      labelPanelSettingsIncludes={t('templateAdmin.panel.settings.operators.includes')}
                      labelPanelDisplayPropertiesTitle={t('templateAdmin.panel.display.title')}
                      labelPanelAddPropertiesTitle={t('templateAdmin.panel.addProperties.title')}
                      labelPanelAddBtnAdd={t('templateAdmin.panel.addProperties.buttons.add')}
                      labelPanelAddBtnCancel={t('templateAdmin.panel.addProperties.buttons.cancel')}
                      labelMovListAvailable={t('templateAdmin.move.available')}
                      labelMovListSelected={t('templateAdmin.move.selected')}
                      labelIconOperatorDelete={t('templateAdmin.form.icons.delete')}
                      labelIconOperatorSetting={t('templateAdmin.form.icons.settings')}
                      labelIconOperatorUp={t('templateAdmin.form.icons.up')}
                      labelIconOperatorDown={t('templateAdmin.form.icons.down')}
                      labelPanelMenusTitle={t('templateAdmin.panel.menus.title')}
                    />
                  </div>
                )}
              />
            </Switch>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12" style={{ height: '1px' }}>
            {renderToastContainer()}
          </div>
        </div>
      </div>
    );
  }

  private onCustomBuildColumns(): IColumn[] {
    console.log('Set custom columns');
    return [
      {
        key: 'name',
        name: 'Name',
        fieldName: 'name',
        minWidth: 210,
        maxWidth: 350,
        isRowHeader: true,
        isResizable: false,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
        data: 'string',
        isPadded: true
      }
    ];
  }

  private onSelectionChanged(selection: IObjectWithKey[]) {
    if (selection.length === 1) {
      this.props.history.push(`/search/template/${(selection[0] as any).id}/edit`);
    } else {
      this.props.history.push(`/search/template/`);
    }
  }

  private isNull(value: any) {
    return value == null || value === 'null' || value === undefined;
  }

  private handleResponse(items: any[]) {
    return items;
  }

  private getUrl(search: string, page: number, sortBy?: string, sortDesc?: boolean) {
    const qValue = this.isNull(search) ? '' : `&q=${search}`;
    const sortByValue = this.isNull(sortBy) ? '' : `&_sort=${sortBy}`;
    let sortDescValue = '';

    if (!this.isNull(sortDesc)) {
      sortDescValue = sortDesc ? '&_order=desc' : '&_order=asc';
    }
    const url = `${URL_BASE}templates/?_start=${page}&_limit=20${qValue}${sortByValue}${sortDescValue}`;
    return url;
  }

  private onCancel(): void {
    console.log('onCancel ...');
    this.selection.setAllSelected(false);

    this.props.history.push(`/search/template/`);
  }

  private onSubmitSuccess(response: any): void {
    console.log('onSubmitSuccess ...', response);
    const id = this.getId();
    const message = id ? 'Template edited.' : 'Template created';
    const msg: ISuccessMessage = {
      title: 'Success',
      message
    };
    successToast(msg);
    this.selection.setAllSelected(false);
    this.props.history.push(`/search/template/`);
  }

  private onSubmitError(error: any): void {
    const errorObj = error.response.data;
    const id = this.getId();
    const title = id ? 'Error editing Template' : 'Error creating new Template';

    const msg: IErrorMessage = {
      title,
      message: errorObj.message,
      error: errorObj
    };
    errorToast(msg);
  }

  private getItems = () => {
    const { t } = this.props;
    return [
      {
        key: 'newItem',
        name: t('templateAdmin.list.cmdBar.new'),
        iconProps: {
          iconName: 'Add'
        },
        onClick: this.onNew
      }
    ];
  };

  private getFarItems = () => {
    const { t } = this.props;
    return [
      {
        key: 'delete',
        name: t('templateAdmin.list.cmdBar.delete'),
        iconProps: {
          iconName: 'Delete'
        },
        onClick: this.onDelete
      }
    ];
  };

  private getId(): any {
    return /\d+/.exec(this.props.location.pathname);
  }

  private onNew() {
    this.selection.setAllSelected(false);
    this.props.history.push(`/search/template/new`);
  }

  private onDelete(): any {
    const id = this.getId();
    if (!id) {
      return;
    }
    Api.delete(`templates/${id}`)
      .then(response => {
        const msg: ISuccessMessage = {
          title: 'Success',
          message: 'Template Deleted with success!'
        };
        successToast(msg);
        this.selection.setAllSelected(false);
        this.props.history.push(`/search/template/`);
      })
      .catch(error => {
        const data = error.response.data;
        const msg: IErrorMessage = {
          title: 'Error',
          message: `Error Deleting Template: ${data.status}:${data.message}`,
          error: data
        };
        errorToast(msg);
      });
  }

  private getDynamicTranslationInternal = (keySuffix: string): string => {
    if (!keySuffix) {
      return keySuffix;
    }
    const { t } = this.props;
    const key = `templateAdmin.form.dynamic.${keySuffix.toLowerCase()}`;
    const value = t(key);

    return value !== key ? value : keySuffix;
  };
}

export default withRouter(connect(
  null,
  mapDispatchToProps
)(withTranslation()(TemplateAdmin)) as any);
